<template>
  <div class="tw-max-h-full">
    <GraphqlDataTable
      :query
      :order-by="initialOrder"
      :filter-black-list="['accounts']"
      :max-height-adjustment="60"
    >
      <template #action="{ row }">
        <IncomingJobActionColumn :row="row" />
      </template>
    </GraphqlDataTable>
  </div>
</template>

<script lang="ts" setup>
import { TypedQueryDocumentNode } from 'graphql/index'
import GraphqlDataTable from '@/components/GraphqlDataTable/GraphqlDataTable.vue'
import { graphql } from '@/gql'
import IncomingJobActionColumn from '@/components/GraphqlDataTable/columns/Job/IncomingJobActionColumn.vue'
import { JobOrderByColumn, SortOrder } from '@/gql/graphql'

const query = graphql(`
  query IncomingJobsQuery(
    $search: String
    $page: Int!
    $first: Int!
    $orderBy: [JobsOrderByClauseInput!]
  ) {
    incomingJobs(
      search: $search
      page: $page
      first: $first
      orderBy: $orderBy
    ) {
      data {
        ...JobCreatedAtColumn
        ...JobStatusColumn
        ...JobStartDateColumn
        ...JobEndDateColumn
        ...IncomingJobActionColumn
      }
    }
  }
`) as TypedQueryDocumentNode

const initialOrder = {
  field: JobOrderByColumn.CreatedAt,
  order: SortOrder.Desc,
}
</script>
